import { defineNotificationCategory } from './types';

export const portfolioCreatedDescriptor = defineNotificationCategory('portfolio_created', {
  actionUrl: (data, organizationId) => `/org-id/${organizationId}/loop/${data.loopId}`,
  pills: () => ['Portfolio'],
});

export const teamAssignmentChangedDescriptor = defineNotificationCategory(
  'team_assignment_changed',
  {
    actionUrl: (data, organizationId) => `/org-id/${organizationId}/loop/${data.loopId}`,
    pills: () => ['Team'],
  },
);

export const planPublishedDescriptor = defineNotificationCategory('plan_published', {
  actionUrl: (data, organizationId) => `/org-id/${organizationId}/loop/${data.loopId}`,
  pills: () => ['Portfolio'],
});

// Deliberately not `nonDisableable` — that list is a product designation (see
// registry-invariants.test.ts), so this stays togglable like any other planner notification.
export const scenarioOperationFailedDescriptor = defineNotificationCategory(
  'scenario_operation_failed',
  {
    actionUrl: (data, organizationId) =>
      `/org-id/${organizationId}/loop/${data.loopId}/planner/scenario/${data.scenarioId}`,
  },
);

const objectiveJumpUrl = (
  data: { objectiveId: number; loopId?: number | null },
  organizationId: string,
) => {
  const path =
    data.loopId != null
      ? `/org-id/${organizationId}/loop/${data.loopId}/strategy`
      : `/org-id/${organizationId}/objectives`;
  return `${path}?jumpToObjectiveId=${data.objectiveId}`;
};

export const objectiveHealthChangedDescriptor = defineNotificationCategory(
  'objective_health_changed',
  {
    actionUrl: objectiveJumpUrl,
    pills: () => ['OKR'],
  },
);

export const objectiveDriftDetectedDescriptor = defineNotificationCategory(
  'objective_drift_detected',
  {
    actionUrl: objectiveJumpUrl,
    nonDisableable: true,
    pills: () => ['OKR'],
  },
);

export const exportCompletionDescriptor = defineNotificationCategory('export_completion', {
  actionUrl: (data, organizationId) =>
    data.target === 'dashboard'
      ? `/org-id/${organizationId}/dashboards/${data.dashboardId}`
      : `/org-id/${organizationId}/loop/${data.loopId}/visualizations/view/${data.viewId}/${data.visualizationType}`,
  pills: (_data, ctx) => (ctx.loopName ? [ctx.loopName, 'Export'] : ['Export']),
});

export const aiDashboardGenerationCompletedDescriptor = defineNotificationCategory(
  'ai_dashboard_generation_completed',
  {
    actionUrl: (data, organizationId) =>
      data.dashboardId
        ? `/org-id/${organizationId}/dashboards/${data.dashboardId}`
        : `/org-id/${organizationId}/dashboards`,
    pills: () => ['AI Dashboard'],
  },
);
